export const enum AppstoreApiKeyFormEnum {
    issuerId = 'issuerId',
    keyId = 'keyId',
    privateKey = 'privateKey',
}

export type AppstoreApiKeyFormType = {
    [AppstoreApiKeyFormEnum.issuerId]: string;
    [AppstoreApiKeyFormEnum.keyId]: string;
    [AppstoreApiKeyFormEnum.privateKey]: File;
};
